import React from 'react';
import { colors } from './colors';
import TriangleWarning from 'icons/indexed-icons/TriangleWarning';
import Stop from 'icons/indexed-icons/Stop';
import MachineError from 'icons/indexed-icons/MachineError';
import ExternalError from 'icons/indexed-icons/ExternalError';
import Offline from 'icons/indexed-icons/Offline';
import ProcessError from 'icons/indexed-icons/ProcessError';
import CheckCircle2 from 'icons/indexed-icons/CheckCircle2';
//machine status
import { default as DisconnectedIcon } from '../../../../../components/MachineStatus/icons/status_disconnected.svg';
import { default as ConnectedIcon } from '../../../../../components/MachineStatus/icons/status_connected.svg';


export const Icons: Record<string, JSX.Element> = {
  undefined: <TriangleWarning color={colors?.['undefined']} />,
  'stopped by operator': <Stop color={colors?.['stopped by operator']} />,
  'machine running': <CheckCircle2 color={colors?.['machine running']} />,
  'machine error': <MachineError color={colors?.['machine error']} />,
  'external error': <ExternalError color={colors?.['external error']} />,
  'process error': <ProcessError color={colors?.['process error']} />,
  'offline': <Offline color={colors?.['offline']} />,
  'new undefined error': <TriangleWarning color={colors?.['new undefined error']} />,
  'online': <CheckCircle2 color={colors?.['machine running']} />,
  'connected': <img className='machine_status' src={ConnectedIcon} />,
  'disconnected': <img className='machine_status' src={DisconnectedIcon} />,
};
